//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let token = localStorage.getItem("token-admin")
export default {
  name: "data",
  data: function(){
    return {
      id: '',
      data: { history: "" }, opsi : ['Eselon I', 'Eselon II'],
      
      editorSetting: [
              [ {
                  label: this.$q.lang.editor.align,
                  icon: this.$q.iconSet.editor.align,
                  fixedLabel: true,
                  list: 'only-icons',
                  options: ['left', 'center', 'right', 'justify']
                },],
                [ {
                  label: 'Text',
                  fixedLabel: true,
                  list: 'only-icons',
                  options: ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript']
                },],
              ['hr', 'link'],
              ['undo', 'redo'],
              ['print', 'fullscreen'],],
      slcLHKPN: '',
      slcProfile: '',
      theFile:{},
    };
  },
  mounted() {
    this.id = this.$route.params.id
    if (this.id != -1) {
      this.id = this.id
      this.getPejabat();
    }

  },
  methods: {
    chgProfile(){
      if(this.$refs.profile.files[0])
        this.slcProfile = this.$refs.profile.files[0].name
      else
        this.slcProfile = ''
    },
    chgLHKPN(){
      if(this.$refs.lhkpn.files[0])
        this.slcLHKPN = this.$refs.lhkpn.files[0].name
      else
        this.slcLHKPN = ''
    },
    getPejabat() {
      this.$http
        .get("/pejabat_byid/" + this.id, {
          headers: { Authorization: "Bearer " + token}
        })
        .then((result) => {
          this.data = result.data;
        });
    },
    onSubmit() {
      this.$refs.name.validate(); 
      this.$refs.position.validate();
      this.$refs.eselon.validate();
      this.data.history = this.data.history.replace(/"/g,'\'')
      if (
        this.$refs.name.hasError ||
        this.$refs.position.hasError ||
        this.$refs.eselon.hasError
      ) {
        this.formHasError = true;
      } 
      else {
        if (this.data.id) {
          this.data.updatedBy = this.$store.state.currentAdmin.username
          this.data.updatedDate = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
          this.$http
            .put(
              "/update_pejabat/" + this.id, this.data,{
                headers: { Authorization: "Bearer " + token}
              })
            .then((result) => {
              this.upload(this.data.id)
            });
        } else {
          this.data.createdBy = this.$store.state.currentAdmin.username
          this.$http
            .post("/new_pejabat/", this.data, {
              headers: { Authorization: "Bearer " + token}
            })
            .then((result) => {
              this.upload(result.data)
            });
        }
      }
    },
    upload(id){
        this.theFile = this.$refs.lhkpn.files[0];
        if(this.theFile){
          var newData = {lhkpn: this.theFile.name}
          var formData = new FormData();
          formData.append("file", this.theFile);
          formData.append("folder", "LHKPN/" + this.data.eselon);
          this.$http
            .post("/upload.php", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((result) => {
              this.$http
                .put( "/update_pejabat/" + id, newData,{
                  headers: { Authorization: "Bearer " + token}
                })
                .then((result) => {
                  
                });
            })
        }

        this.theProfile = this.$refs.profile.files[0];
        if(this.theProfile){
          var newData = {profile: this.theProfile.name}
          var formData = new FormData();
          formData.append("file", this.theProfile);
          formData.append("folder", "profile-card/");
          this.$http
            .post("/upload.php", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((result) => {
              this.$http
                .put( "/update_pejabat/" + id, newData,{
                  headers: { Authorization: "Bearer " + token}
                })
                .then((result) => {
                  
                });
            })
        }
        this.$router.push("/admin/pejabat");
        this.$q.notify({
          icon: "done",
          color: "positive",
          message: "Saved",
        });
    }
  },
};
